import Vue from 'vue';
import { gsap } from 'gsap';

import { Cursor } from '../classes/Cursor';

Vue.component('cases-page', {
    data() {
        return {};
    },

    mounted() {
        this.cursor = new Cursor(document.querySelector('.cursor'));

        this.cursor.addGridEvents('.case-grid-item__inner');

        const cases = document.querySelectorAll('.case-grid-item');

        for (let index = 0; index < cases.length; index++) {
            const element = cases[index];

            function transitionHandle(event) {
                if (event.propertyName !== 'transform') {
                    return;
                }

                element.removeEventListener('transitionend', transitionHandle);
                element.classList.add('--revealed');
            }

            element.addEventListener('transitionend', transitionHandle);

            const delay = Math.random() * 0.5;
            gsap.delayedCall(delay, () => {
                element.classList.toggle('--reveal');
            });
        }

        gsap.to(
            ['.footnote', '.footer-links'],
            {
                duration: 0.3, autoAlpha: 1, y: 0, ease: 'power4.easeOut',
            },
            0.5,
        );
    },
});
